import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './assets/css/style.scss';
import { useEffect, useState } from 'react';
import { FotoKryesore } from '../../../shared/interfaces';

function Slider() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const [images, setImages] = useState<FotoKryesore[]>([]);

  useEffect(() => {
    fetch(`https://strapi-production-a706.up.railway.app/api/foto-kryesores?populate=image`)
      .then((res) => res.json())
      .then((data) => setImages(data.data))
      .catch((err) => console.error('Failed to fetch images:', err));
  }, []);

  return images.length > 0 ? (
    <Carousel
      responsive={responsive}
      className="slider slider--main"
      autoPlay={true}
      infinite={true}
      autoPlaySpeed={0}
      transitionDuration={5000}
      customTransition="all 10s linear"
      arrows={false}
      draggable={false}
      swipeable={false}
    >
      {images?.map((image, i) => (
        <div className="slider__item" key={i}>
          <img
            src={
              image?.image?.formats?.large?.url ||
              image?.image?.url
            }
            alt={`carousel-${i + 1}`}
          />
        </div>
      ))}
    </Carousel>
  ) : null;
}

export default Slider;
